export default "__VITE_ASSET__tYVTz$Lb__"